import { render, staticRenderFns } from "./AbastoComponents.vue?vue&type=template&id=a0ada068&scoped=true"
import script from "./AbastoComponents.vue?vue&type=script&lang=js"
export * from "./AbastoComponents.vue?vue&type=script&lang=js"
import style0 from "./AbastoComponents.vue?vue&type=style&index=0&id=a0ada068&prod&scoped=true&lang=css"
import style1 from "@/other/assets/css/app.css?vue&type=style&index=1&id=a0ada068&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0ada068",
  null
  
)

export default component.exports